export default {
    title: 'Ocorreu um erro',
    text: 'Ocorreu um erro, tente novamente mais tarde.',
    color: 'danger'
}